"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCountryStencil = exports.countryStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.countryStencilDefinition = {
    view: {
        label: 'Country',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['geodata'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'geodata'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: ['country-code'],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
        ],
    },
    content: {
        'country-code': properties_1.countryCodePropertyDefinition,
        geodata: properties_1.geoDataPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        title: properties_1.titlePropertyDefinition,
    },
    localizations: [],
    roles: ['taxonomy-manager'],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'illume',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-advancedtechnologies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
    ],
    name: 'country',
};
const isCountryStencil = (stencil) => {
    return stencil.name === exports.countryStencilDefinition.name;
};
exports.isCountryStencil = isCountryStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL2NvdW50cnkuc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw4Q0FNc0I7QUFFVCxRQUFBLHdCQUF3QixHQUFHO0lBQ3RDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxTQUFTO1FBQ2hCLEtBQUssRUFBRSxPQUFPO1FBQ2QsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxDQUFDLFNBQVMsQ0FBQztRQUN2QixZQUFZLEVBQUU7WUFDWjtnQkFDRSxJQUFJLEVBQUUsTUFBTTtnQkFDWixLQUFLLEVBQUUsQ0FBQyxPQUFPLEVBQUUsU0FBUyxDQUFDO2FBQzVCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxTQUFTO3dCQUNmLEtBQUssRUFBRSxDQUFDLGNBQWMsQ0FBQztxQkFDeEI7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFVBQVU7d0JBQ2hCLEtBQUssRUFBRSxDQUFDLFlBQVksQ0FBQztxQkFDdEI7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLG1CQUFtQjt3QkFDekIsS0FBSyxFQUFFLENBQUMsc0JBQXNCLENBQUM7cUJBQ2hDO2lCQUNGO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsY0FBYyxFQUFFLDBDQUE2QjtRQUM3QyxPQUFPLEVBQUUsc0NBQXlCO1FBQ2xDLHNCQUFzQixFQUFFLGtEQUFxQztRQUM3RCxVQUFVLEVBQUUseUNBQTRCO1FBQ3hDLEtBQUssRUFBRSxvQ0FBdUI7S0FDL0I7SUFDRCxhQUFhLEVBQUUsRUFBRTtJQUNqQixLQUFLLEVBQUUsQ0FBQyxrQkFBa0IsQ0FBQztJQUMzQixNQUFNLEVBQUU7UUFDTixTQUFTO1FBQ1QsdUJBQXVCO1FBQ3ZCLEtBQUs7UUFDTCxRQUFRO1FBQ1IsUUFBUTtRQUNSLFVBQVU7UUFDViw0QkFBNEI7UUFDNUIsYUFBYTtRQUNiLGNBQWM7UUFDZCxlQUFlO1FBQ2YsWUFBWTtRQUNaLDhCQUE4QjtRQUM5QixnQkFBZ0I7UUFDaEIscUJBQXFCO1FBQ3JCLGFBQWE7UUFDYixhQUFhO1FBQ2IsY0FBYztRQUNkLFlBQVk7UUFDWixLQUFLO0tBQ047SUFDRCxJQUFJLEVBQUUsU0FBUztDQUNlLENBQUE7QUFJekIsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLE9BQW9CLEVBQTZCLEVBQUU7SUFDbEYsT0FBTyxPQUFPLENBQUMsSUFBSSxLQUFLLGdDQUF3QixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLGdCQUFnQixvQkFFNUIifQ==